import { CustomerTenantModel } from 'app/shared/components/pickers/customer-tenant-picker/models/customer-tenant-model';
import { LaboratoryTenantModel } from 'app/shared/components/pickers/laboratory-tenant-picker/models/laboratory-tenant-model';
import { TenantSelectorModel } from '../models/tenant-selector.model';

export class TenantSelectorModelHelper {
  public static build(): TenantSelectorModel {
    const tenantSelector = new TenantSelectorModel();
    tenantSelector.customerTenant = new CustomerTenantModel();
    tenantSelector.displayCustomerTenantPickerFlag = false;
    tenantSelector.displayLaboratoryTenantPickerFlag = false;
    tenantSelector.laboratoryTenant = new LaboratoryTenantModel();
    return tenantSelector;
  }
}
